const locales = {
  CH: 'de-CH',
  DE: 'de',
  EN: 'en',
} as const;

export default locales;
